import {MessagingStatusesEnum} from '@spa/api';
import {AutocompleteControl, Helper, SelectControl} from 'appShared/classes';
import {Validators} from '@angular/forms';
import {ComponentTypesEnum} from 'appShared/enums';

export const EmailTemplateFooterSelector = 'emailTemplateFooter';
export const EmailTemplateHeaderSelector = 'emailTemplateHeader';
export const EmailTemplateSignatureSelector = 'emailTemplateSignature';

export const MessageTemplateCustomerSelector = 'customerId';
export const MessageTemplateCustomerProductIdSelector = 'customerProductId';
export const MessageTemplateIdSelector = 'messageTemplateId';
export const MessageTemplateTemplateNameSelector = 'messageTemplateTemplateName';
export const MessageTemplateStatusSelector = 'messageTemplateStatus';
export const MessageTemplateSubjectSelector = 'messageTemplateSubject';
export const MessageTemplateBodySelector = 'messageTemplateBody';
export const MessageTemplateImportanceLevelSelector = 'messageTemplateImportanceLevel';
export const MessageTemplateDistributionChannelsSelector = 'messageTemplateDistributionChannels';
export const MessageTemplateKeyCodeSelector = 'MessageTemplateKeyCode';
export const MessageTemplateKeyDescriptionSelector = 'MessageTemplateKeyDescriptionSelector';
export const MessageTemplateTemplateTypeSelector = 'messageTemplateTemplateType';
export const MessageTemplateCompanySelector = 'messageTemplateCompany';
export const MessageTemplateDepartmentSelector = 'messageTemplateDepartmentSelector';
export const MessageTemplateChannelEmailSelector = 'messageTemplateChannelEmailSelector';
export const MessageTemplateChannelPushSelector = 'messageTemplateChannelPushSelector';
export const MessageTemplateChannelPullSelector = 'messageTemplateChannelPullSelector';
export const MessageTemplatePushNotificationBodySelector = 'messageTemplatePushNotificationBodySelector';

export const EmailTemplateFieldNameSignature = 'Signature';
export const EmailTemplateFieldNameHeader = 'Header';
export const EmailTemplateFieldNameFooter = 'Footer';

export const MessageTemplateFieldKeyDescription = 'Key Description';
export const MessageTemplateFieldBaseTemplateName = 'Name of the base template';
export const MessageTemplateFieldNameStatus = 'Status';
export const MessageTemplateFieldNameTemplateName = 'Template Name';
export const MessageTemplateFieldNameDepartment = 'Department';
export const MessageTemplateFieldNameCompany = 'Company Name';
export const MessageTemplateFieldCustomerProduct = 'Customer Product';
export const MessageTemplateFieldNameApprovedBy = 'Approved By';
export const MessageTemplateFieldNameID = 'Id';
export const MessageTemplateFieldNameAuthor = 'Author';
export const MessageTemplateFieldNameBody = 'Body';
export const MessageTemplateFieldNameSubject = 'Subject';
export const MessageTemplateFieldNameImportanceLevel = 'Important';
export const MessageTemplateFieldNameTemplateType = 'Template Type';
export const MessageTemplateFieldNameDistributionChannels = 'Channels';
export const MessageTemplateFieldNameChannelEmail = 'E-mail';
export const MessageTemplateFieldNameChannelPush = 'Push';
export const MessageTemplateFieldNameChannelPull = 'Pull';
export const MessageTemplateFieldNamePushNotificationBody = 'Push Notification Body';

export const prepareCompanyFilterControl = () => {
    return {
        name: MessageTemplateCompanySelector,
        placeholder: MessageTemplateFieldNameCompany,
        controls: [
            new AutocompleteControl({
                name: MessageTemplateCompanySelector,
                value: null,
                placeholder: MessageTemplateFieldNameCompany,
                validators: [],
                componentType: ComponentTypesEnum.Autocomplete,
                options: [],
            }),
        ],
        sortIndex: 4,
    };
};

export const prepareProductFilterControl = () => {
    return {
        name: MessageTemplateCustomerProductIdSelector,
        placeholder: MessageTemplateFieldCustomerProduct,
        controls: [
            new AutocompleteControl({
                name: MessageTemplateCustomerProductIdSelector,
                value: null,
                placeholder: MessageTemplateFieldCustomerProduct,
                validators: [],
                componentType: ComponentTypesEnum.Autocomplete,
                options: [],
            }),
        ],
        sortIndex: 7,
    };
};

export const prepareStatusFilterControl = (selector: string) => {
    return {
        name: selector,
        placeholder: MessageTemplateFieldNameStatus,
        controls: [
            new SelectControl({
                name: selector,
                value: null,
                placeholder: MessageTemplateFieldNameStatus,
                validators: [Validators.required],
                componentType: ComponentTypesEnum.Select,
                options: [
                    {
                        label: Helper.textsHelper().getMessagingStatusName(MessagingStatusesEnum.PendingApproval),
                        value: MessagingStatusesEnum.PendingApproval
                    },
                    {
                        label: Helper.textsHelper().getMessagingStatusName(MessagingStatusesEnum.Rejected),
                        value: MessagingStatusesEnum.Rejected
                    },
                    {
                        label: Helper.textsHelper().getMessagingStatusName(MessagingStatusesEnum.Approved),
                        value: MessagingStatusesEnum.Approved
                    },
                ],
            })
        ],
        sortIndex: 1
    };
};
